import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react'

import Select, { components } from "react-select";
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';
import './relationship.css';

import {GetJobNames, GetKpiNames, GetProcessNames, GetfilterdJobNames, GetAllPages, GetAllentities, GetAlldivision, GetroleNames, GetroleName, SavePermissions} from '../../../services/process/process_data/process_data';


const identifier2 = [
    { value: "string", label: "string" },
    { value: "int", label: "int" },
    { value: "special charectors", label: "special charectors" },
    { value: "contains", label: "contains" },
    { value: "starts with", label: "starts with" },
    { value: "ends with", label: "ends with" },

];

const identifier1 = [
    { value: "amount", label: "amount" },
    { value: "date", label: "date" },

];

const roles = [
    { value: "admin", label: "admin" },
    { value: "manager", label: "manager" },
    { value: "ceo", label: "ceo" },

];


const ValueContainer = ({ children, getValue, ...props }) => {
    let maxToShow = 1;
    var length = getValue().length;
    let displayChips = React.Children.toArray(children).slice(0, maxToShow);
    let shouldBadgeShow = length > maxToShow;
    let displayLength = length - maxToShow;
  
    return (
      <components.ValueContainer {...props}>
        {!props.selectProps.inputValue && displayChips}
        <div className="root">
          {/* {shouldBadgeShow &&
            `+ ${displayLength} item${length != 1 ? "s" : ""} selected`} */}
        </div>
      </components.ValueContainer>
    );
  };

const Permission = () => {
  const [roleName, setRoleName] = useState('');
  const [description, setDescription] = useState('');
  const [designation, setdesignation] = useState('');
  const [grade, setgrade] = useState('');
  
  const [rolecoach, setrolecoach] = useState('');


  const [limits, setlimits] = useState([]);
  const [selectedpages, setSelectedpages] = useState([]);
  const [selectedpages1, setSelectedpages1] = useState([]);
  const [selectedpages2, setSelectedpages2] = useState([]);

  const [selectedentity, setSelectedentity] = useState([]);
  const [selectedentity1, setSelectedentity1] = useState([]);

  const [selecteddivision, setSelecteddivision] = useState([]);
  const [selecteddivision1, setSelecteddivision1] = useState([]);

  const [role, setrole] = useState({});
  const [role1, setrole1] = useState({});
  
  const [selectedprocess, setSelectedprocess] = useState([]);
  const [selectedprocess1, setSelectedprocess1] = useState([]);

  const [selectedJobs, setSelectedJobs] = useState([]);
  
  const [selectedJobs1, setSelectedJobs1] = useState([]);

    
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));



  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
        return (shouldBeShown(value) ?  { display: 'none'} : { ...base } );
    }
};

  

  const savePermissions = () =>{
    
    let payload = {
        // 'process_id':'',
        // 'tenants': userCredentials["tenants_id"],
        // 'groups': userCredentials["groups_id"],
        // 'entities': userCredentials["entities_id"],
        'role_id': role.value,
        'role_name': roleName,
        'role_description': description,
        'role_designation': designation,
        'role_grade': grade,
        'process': selectedprocess,
        'jobs': selectedJobs,
        'pages': selectedpages,
        'entity': selectedentity,
        'divisions': selecteddivision,
        'limits': limits
        
    }
    console.log('payload', payload)
    var FileUploadCredentials = SavePermissions();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                window.location.reload();
            }
        )
        .catch((error) => {
            console.error("Error in POST request:", error);
          });
  }


  const fetchfilteredjobnames = (value) => {

    let payload = {
        'id': value.value,
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetfilterdJobNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response jobs!!!", response);
                let table_data = response.data;
                let table_data1 = table_data[0].jobs
                console.log('table_data1', table_data1)
                let names = selectedJobs1;
                table_data1.map((data) => {

                    let obj = {
                        value: data.value,
                        label: data.label
                    }
                    names.push(obj);
                })
                setSelectedJobs1(names);
            }
        )
}

  const handleSelectChange = (event, { value }) => {
    console.log('event process', event);
    let targetProcessId = event[0].value;
    console.log('targetProcessId', targetProcessId, selectedpages1)
    const filteredPages = selectedpages1.filter(page => page.key === targetProcessId);
    const filteredNonNullData = filteredPages.filter((item) => item.process_id !== null);
    console.log('filteredNonNullData', filteredNonNullData, filteredPages)
    setSelectedpages2(filteredNonNullData);
    setSelectedprocess(event);
    let index = null;
    for (let events in event){
        console.log('events', events);
        index = events;
    }
    // console.log(event[index]);
    fetchfilteredjobnames(event[index]);
  };

  const handleSelectChange1 = (event, { value }) => {
    setSelectedJobs(event);
  };

  const handleSelectChange2 = (event, { value }) => {
    setSelectedpages(event);
  };

  const handleSelectChange3 = (event, { value }) => {
    setSelectedentity(event);
  };

  const handleSelectChange4 = (event, { value }) => {
    setSelecteddivision(event);
  };

  const handleSelectChange5 = (event, { value }) => {
    setlimits(event);
  };
//   const handleSelectChange5 = (event, { value }) => {
//     setProcessCategory(event);
//   };
 
  




  const fetchProcessNames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetProcessNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response!!!", response);
                let table_data = response.data;

                let names = [];
                table_data.map((data) => {

                    let obj = {
                        value: data.process_id,
                        label: data.process_name
                    }
                    names.push(obj);
                })
                setSelectedprocess1(names);
            }
        )
}



const fetchallpagesnames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetAllPages();

    axios.get(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response pages!!!", response);
                let table_data = response.data;
                table_data = table_data['data_out']
                let names = [];
                if (Array.isArray(table_data)){
                table_data.map((data) => {

                    let obj = {
                        value: data.pages_id,
                        label: data.name,
                        key: data.process_id
                    }
                    names.push(obj);
                })
                }
                setSelectedpages1(names);
            }
        )
}

const fetchallentitynames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetAllentities();

    axios.get(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response entity!!!", response);
                let table_data = response.data;
                table_data = table_data['data_out']
                let names = [];
                if (Array.isArray(table_data)){
                table_data?.map((data) => {

                    let obj = {
                        value: data.entity_id,
                        label: data.name
                    }
                    names.push(obj);
                })
                }
                setSelectedentity1(names);
            }
        )
}

const fetchalldivisionnames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetAlldivision();

    axios.get(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response divisions!!!", response);
                let table_data = response.data;
                table_data = table_data['data_out']
                let names = [];
                if (Array.isArray(table_data)){
                table_data?.map((data) => {

                    let obj = {
                        value: data.division_id,
                        label: data.name
                    }
                    names.push(obj);
                })
                }
                setSelecteddivision1(names);
            }
        )
}


const fetchrolenames = (id) => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        'id':id
    }

    var FileUploadCredentials = GetroleName();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response role!!!", response);
                let data = response.data;

                if(data){
                    setrolecoach(data[0].role_coach);
                    setRoleName(data[0].role_name);
                    setDescription(data[0].description);
                    setdesignation(data[0].designation)
                    setgrade(data[0].grade);
                }
                
            }
        )
}

const handleRole = (event) =>{
    setrole(event);
    fetchrolenames(event.value);
 }


const fetchallrolenames = () => {

    let payload = {
        'tenants': userCredentials["tenants_id"],
        'groups': userCredentials["groups_id"],
        'entities': userCredentials["entities_id"],
        
    }

    var FileUploadCredentials = GetroleNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
        .then(
            response => {
                console.log("Validate Credentials Response role!!!", response);
                let table_data = response.data;

                let names = [];
                let id = '';
                if (Array.isArray(table_data)){
                table_data?.map((data) => {
                    id = data.id;
                    let obj = {
                        value: data.id,
                        label: data.role_name
                    }
                    names.push(obj);
                })
                }
                setrole1(names);
            }
        )
}

useEffect(() => {
    // fetchjobnames();
    // fetchkpinames();
    // fetchsourcenames();
    fetchallrolenames();
    fetchProcessNames();
    fetchallpagesnames();
    fetchallentitynames();
    fetchalldivisionnames();

}, []);

    return (
        <>
        <Grid item style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <div style={{width:'100%'}}>
        <h2 className=" pt-1 pb-1 text-center" style={{ color: "#4969ab"}}>PERMISSIONS</h2>
      </div>
      </Grid>
        <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
            <Grid.Row >
            <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Role Id</label> <br />
                        
                        <Select
                            clearable
                            options={role1}
                            selection
                            size='mini'
                            value={role}
                            onChange={handleRole}
                        />
                    </div>
                </Grid.Column>
            <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Role name</label> <br />
                        <Input
                            type="text"
                            style={{width:'100%'}}
                            placeholder="RoleName"
                            className="resource_input"
                            value={roleName}
                            onChange={(e) => setRoleName(e.target.value)}

                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Description</label> <br />
                        <Input
                            type="text"
                            style={{width:'100%'}}
                            placeholder="Description"
                            className="resource_input"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                </Grid.Column>

                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Designation</label> <br />
                        <Input
                            type="text"
                            style={{width:'100%'}}
                            placeholder="designation"
                            className="resource_input"
                            value={designation}
                            onChange={(e) => setdesignation(e.target.value)}
                        />
                        
                    </div>
                </Grid.Column>
                <Grid.Column>
                <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Grade</label> <br />
                        <Input
                            type="text"
                            style={{width:'100%'}}
                            placeholder="grade"
                            className="resource_input"
                            value={grade}
                            onChange={(e) => setgrade(e.target.value)}
                        />
                        
                    </div>
                </Grid.Column>
                <Grid.Column>
                <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`endPositionInput`}>Role Coach</label> <br />
                        <Input
                            type="text"
                            style={{width:'100%'}}
                            placeholder="role coach"
                            className="resource_input"
                            value={rolecoach}
                            onChange={(e) => setrolecoach(e.target.value)}
                        />
                        
                    </div>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
            <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Process</label> <br />
                        <Select
                            clearable
                            options={selectedprocess1}
                            selection
                            isMulti
                            size='mini'
                            value={selectedprocess}
                            onChange={handleSelectChange}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}
                        />
                    </div>
                </Grid.Column>
                
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Jobs</label> <br />
                        <Select
                            clearable
                            isMulti
                            options={selectedJobs1}
                            selection
                            size='mini'
                            value={selectedJobs}
                            onChange={handleSelectChange1}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Pages</label> <br />
                        <Select
                            clearable
                            options={selectedpages2}
                            selection
                            isMulti
                            size='mini'
                            value={selectedpages}
                            onChange={handleSelectChange2}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Entity</label> <br />
                        <Select
                            clearable
                            options={selectedentity1}
                            selection
                            isMulti
                            size='mini'
                            value={selectedentity}
                            onChange={handleSelectChange3}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Divisions</label> <br />
                        <Select
                            clearable
                            options={selecteddivision1}
                            selection
                            isMulti
                            size='mini'
                            value={selecteddivision}
                            onChange={handleSelectChange4}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}
                        />
                    </div>
                </Grid.Column>
                <Grid.Column>
                    <div className="form-group ">
                        <label className="label1 mb-1" htmlFor={`startPositionInput`}>Limits</label> <br />
                        <Select
                            clearable
                            options={identifier1}
                            selection
                            isMulti
                            size='mini'
                            value={limits}
                            onChange={handleSelectChange5}
                            hideSelectedOptions={false}
                            styles={styles}
                            components={{ ValueContainer }}
                        />
                    </div>
                </Grid.Column>
            </Grid.Row>

        </Grid>
        <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row>
        <Grid.Column>
        {selectedprocess && (
            <table id="customers">
                
                {selectedprocess.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}

        </Grid.Column>
        
        <Grid.Column>
        {selectedJobs && (
            <table id="customers">
                
                {selectedJobs.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
        
        <Grid.Column>
        {selectedpages && (
            <table id="customers">
                
                {selectedpages.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
        <Grid.Column>
        {selectedentity && (
            <table id="customers">
                
                {selectedentity.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
        <Grid.Column>
        {selecteddivision && (
            <table id="customers">
                
                {selecteddivision.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
        <Grid.Column>
        {limits && (
            <table id="customers">
                
                {limits.map((option) => (
                    <tr key={option.value}>
                    <th>{option.label}</th>
                    </tr>
                ))}

            </table>
            )}
        </Grid.Column>
        </Grid.Row>
        </Grid>
        <Grid columns='equal' divided style={{ backgroundColor: "#fff", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Column>
                <div className=" text-center">
                    <button style={{ height: "35px", width: "92px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em' }} onClick={savePermissions}>Save</button>
                </div>
                </Grid.Column>
                {/* <div className="col-md-6 text-center">
                    <button style={{ height: "35px", width: "150px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em' }} >Generate Schema</button>
                </div> */}
            
        
        </Grid>
        </>
       )
    }
    
export default Permission;